import { useTranslation } from 'react-i18next';
import { faPlus, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect, useReducer } from 'react';
import { personService } from '@shared/services/personService';
import SystemDocumentsForm from './SystemDocumentsForm';
import DeleteModal from '@shared/components/DeleteModal';
import PreviousPage from '@shared/components/PreviousPage';
import { useParams } from 'react-router-dom';

export default function SystemDocuments() {
    const { t } = useTranslation();
    const { id: personId } = useParams();
    const [person, setPerson] = useState(location.state?.person || null);

    const initialState = {
        data: [],
        selectedData: null,
        modalState: {
            visible: false,
            type: 'add'
        },
        showDeleteModal: false
    };

    const reducer = (state, action) => {
        switch (action.type) {
            case 'SET_SELECTED_DATA':
                return {
                    ...state, selectedData: action.payload
                }
            case 'SET_MODAL_STATE':
                return {
                    ...state, modalState: action.payload
                }
            case 'SET_SHOW_DELETE_MODAL':
                return {
                    ...state, showDeleteModal: action.payload
                }
            case 'SET_DATA':
                return {
                    ...state, 
                    data: action.payload,
                    selectedData: state.selectedData ? 
                        action.payload.find(item => item.id === state.selectedData.id) || state.selectedData 
                        : null
                }
            default:
                return state
        }
    }
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        if (!person && personId) {
            const fetchPerson = async () => {
                try {
                    const response = await personService.getPersonById(personId);
                    setPerson(response);
                } catch (error) {
                    console.error('Error fetching person:', error);
                }
            };
            fetchPerson();
        }
    }, [personId, person]);


    // const [selectedData, setSelectedData] = useState(null);
    // const [modalState, setModalState] = useState({
    //     visible: false,
    //     type: 'add'
    // });
    // const [showDeleteModal, setShowDeleteModal] = useState(false);
    // const [data, setData] = useState([]);
    const fetchSystemDocuments = async () => {
        const response = await personService.getSystemDocuments(personId);
        dispatch({ type: 'SET_DATA', payload: response });
    };

    useEffect(() => {
        fetchSystemDocuments();
    }, [personId]);


    const handleCheckboxChange = (item) => {
        // setSelectedData(selectedData?.id === item.id ? null : item);
        dispatch({ type: 'SET_SELECTED_DATA', payload: state.selectedData?.id === item.id ? null : item });
    };

    const handleConfirm = async (formData) => {
        await fetchSystemDocuments();
    };

    const handleDeleteConfirm = async (formData) => {
        try {
            await personService.deleteSystemDocument(state.selectedData.id);
            await fetchSystemDocuments();
            dispatch({ type: 'SET_SHOW_DELETE_MODAL', payload: false });
        } catch (error) {
            console.error('Error deleting system document:', error);
        }
    };

    const getDocTypeTranslation = (docType) => {
        const docTypeMap = {
            'type1': 'persons.systemDocuments.sickSheet',
            'type2': 'persons.systemDocuments.disabilitySheet',
            'type3': 'persons.systemDocuments.diploma',
            'type4': 'persons.systemDocuments.certificate',
            'type5': 'persons.systemDocuments.otherDocuments'
        };
        return t(docTypeMap[docType] || docType);
    };

    return (
        <div className="system-documents-container flex-column width-70">
            <div className="table-header">
                <div className="title-section">
                    {person ? (
                        <h1 className="main-heading">
                            {t('persons.systemDocuments.title', {
                                name: [person.name, person.fathersName, person.surname]
                                    .filter(Boolean)
                                    .join(' ')
                            })}
                        </h1>
                    ) : (
                        <h1 className="main-heading">Loading...</h1>
                    )}
                </div>
                <div className="controls-section">
                    <div className="header-icons">
                        <PreviousPage />

                        <button className="icon-button"
                            // title={t('common.add')} onClick={() => setModalState({ visible: true, type: 'add' })}
                            title={t('common.add')} onClick={() => dispatch({ type: 'SET_MODAL_STATE', payload: { visible: true, type: 'add' } })}>
                            <FontAwesomeIcon icon={faPlus} />
                        </button>
                        <button
                            className={`icon-button ${!state.selectedData ? 'disabled-link' : ''}`}
                            // title={t('common.edit')} onClick={() => setModalState({ visible: true, type: 'edit' })}
                            title={t('common.edit')} onClick={() => dispatch({ type: 'SET_MODAL_STATE', payload: { visible: true, type: 'edit' } })}
                        >
                            <FontAwesomeIcon icon={faEdit} />
                        </button>
                        <button
                            className={`icon-button ${!state.selectedData ? 'disabled-link' : ''}`}
                            // title={t('common.delete')} onClick={() => setShowDeleteModal(true)}
                            title={t('common.delete')} onClick={() => dispatch({ type: 'SET_SHOW_DELETE_MODAL', payload: true })}
                        >
                            <FontAwesomeIcon icon={faTrash} />
                        </button>
                    </div>
                </div>
            </div>
            <div className="table-responsive custom-table-container">
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th className="radio-column">
                                <div className="checkbox-wrapper"></div>
                            </th>
                            <th>{t('persons.systemDocuments.docDate')}</th>
                            <th>{t('persons.systemDocuments.docType')}</th>
                            <th>{t('persons.systemDocuments.validUntil')}</th>
                            <th>{t('persons.systemDocuments.description')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {state.data.map((item) => (
                            <tr key={item.id}>
                                <td className="radio-column">
                                    <div className="checkbox-wrapper">
                                        <input
                                            type="checkbox"
                                            checked={state.selectedData?.id === item.id}
                                            onChange={() => handleCheckboxChange(item)}
                                        />
                                    </div>
                                </td>
                                <td>{item.docdate}</td>
                                <td>{getDocTypeTranslation(item.empdoctype)}</td>
                                <td>{item.specdate}</td>
                                <td>{item.description}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {state.modalState.visible && (
                <SystemDocumentsForm
                    // onClose={() => setModalState({ visible: false, type: 'add' })}
                    onClose={() => dispatch({ type: 'SET_MODAL_STATE', payload: { visible: false, type: 'add' } })}
                    onConfirm={handleConfirm}
                    editData={state.modalState.type === 'edit' ? state.selectedData : null}
                    personId={personId}
                    state={state}
                />
            )}
            {state.showDeleteModal && (
                <DeleteModal
                    // onClose={() => setShowDeleteModal(false)}
                    onClose={() => dispatch({ type: 'SET_SHOW_DELETE_MODAL', payload: false })}
                    onConfirm={handleDeleteConfirm}
                    name=""
                    entityType="record"
                />
            )}
        </div>
    );
}
